import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as L from 'leaflet';
import { BehaviorSubject, forkJoin, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LOCATION_UUID, VisibilityMapConstants } from './alert-gis/alert-gis.const';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttperrorhandlerService } from '../../shared/http/httperrorhandler.service';
import { catchError } from 'rxjs/operators';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';
import { isEmptyField } from '../../shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';

@Injectable({
  providedIn: 'root'
})
export class AlertDataService {

  public selectedParams: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public mapObj : BehaviorSubject<any> = new BehaviorSubject<object>({});
  public layerList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public otherOptions: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public currentPlayPosition: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public playButton: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public blockNo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  labelStringValue: BehaviorSubject<object> = new BehaviorSubject<object>(null);
  blocksArray: BehaviorSubject<object> = new BehaviorSubject<object>(null);
  public timestamp: BehaviorSubject<Number> = new BehaviorSubject<Number>(null);
  index: Subject<any> = new Subject();
  public default: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public pointLayerParams: BehaviorSubject<object> = new BehaviorSubject<any>({});
  public selectedHeatMap: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public navigatedLayer :BehaviorSubject<any> = new BehaviorSubject<object>({});
  public selectedPointInfo: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public clickedMapNumber:BehaviorSubject<any> = new BehaviorSubject<any>('');
  public isClusterLayerVisible: BehaviorSubject<any> = new BehaviorSubject<boolean>(false);
  public selectedPointData: BehaviorSubject<any> = new BehaviorSubject<any>({});
  mapArray: any=[5];
  urlConstants = {
    AZURE_GEOSERVER_URL: environment.url.NEW_GEOSERVER_URL,
    WRIMS_URL: environment.url.OBSERVED_API_URL,
    URL: environment.url.HEATWAVE_STAGING_API_URL
    // GEOSERVER_URL_SECOND : environment.url.AZURE_GEOSERVER_URL
    // PLAY_API_URL: environment.urlMapping.PROJ_API
  }

  constructor(
    private errorHandler: HttperrorhandlerService,
    private http: HttpClient
  ) { }

  setIsVisibleOfClusterLayer(value)
  {
    this.isClusterLayerVisible.next(value);
  }

  getIsVisibleOfClusterLayer() {
    return this.isClusterLayerVisible.asObservable();
  }

  setPointData(value)
  {
    this.selectedPointData.next(value);
  }

  getPointData() {
    return this.selectedPointData.asObservable();
  }

  setMapObj(value) {
    this.mapObj.next(value);
  }

  getMapObj() {
    return this.mapObj.asObservable();
  }

  setLabelString(value: any) {
    this.labelStringValue.next(value);
  }

  getLabelString() {
    return this.labelStringValue.asObservable();
  }
  getBlockNumber() {
    return this.blockNo.asObservable();
  }

  setBlockNumber(value: any) {
    this.blockNo.next(value);
  }

  setBlocksArray(value) {
    this.blocksArray.next(value);
  }

  getBlocksArray() {
    return this.blocksArray.asObservable();
  }

  setIndex(index) {
    this.index.next(index);
  }

  setTimestamp(value) {
    this.timestamp.next(value);
  }

  setPlayButton(value: any){
    this.playButton.next(value);
  }

  getPlayButton() {
    return this.playButton.asObservable();
  }

  setDefaultPlayPosition(value)
  {
    this.default.next(value);
  }

  getDefaultPlayPosition() {
    return this.default.asObservable();
  }

  setPointLayerParams(data: any){
    this.pointLayerParams.next(data)
  }

  getPointLayerParams(){
    return this.pointLayerParams.asObservable();
  }

  setSelectedHeatMap(value) {
    this.selectedHeatMap.next(value);
  }

  getSelectedHeatMap() {
    return this.selectedHeatMap.asObservable();
  }

  sendNavigatedLayer(value){
    this.navigatedLayer.next(value);
  }
  getNavigatedLayer(){
    return this.navigatedLayer.asObservable();
   }

  setSelectedPointInfo(value){
    this.selectedPointInfo.next(value);
  }
   
  getSelectedPointInfo(){
    return this.selectedPointInfo.asObservable();
  }
  setClickedMapNumber(value)
  {
    this.clickedMapNumber.next(value);
  }
  getClickedMapNumber()
  {
   return this.clickedMapNumber.asObservable();
  }
 

  get24HrsTimeStamps() {
    const  today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 21600000);
    const blocks = {};
    for (let i = 0; i < 4; i++) {
      blocks[i] = dayStartTs + ((i + blockIndex) * 21600000);
    }
    blocks[4] = blocks[0];
    return blocks;
  }

  get10DaysTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 7; i++) {
      blocks[i] = dayStartTs + ((i) * 86400000);
    }
    return blocks;
  }

  formatNames(string) {
    if (string !== undefined && string != null) {
      return string.replace(/\w\S*/g, function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
    }
  }

  titleCase(str) {
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
 }

 isEmptyObj(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
}

getWritableObject(obj: object): object {
  if (obj == null || obj == undefined) return obj;

  let objectConfig = {};
  for (let key in obj) {
    objectConfig[key] = obj[key];
  }

  return objectConfig;
}
getParentTypeForGivenChildType(cType, locTypeList = []) {
  let pType = null;
  let index = locTypeList.findIndex(locType => locType.toLowerCase() == cType.toLocaleLowerCase());
  if (index > 0) {
    pType = locTypeList[index - 1];
  }
  return pType;
}

getChildTypeForGivenParentType(pType, locTypeList = []) {
  let cType = pType;
  let index = locTypeList.findIndex(locType => locType.toLowerCase() == pType.toLocaleLowerCase());
  if (index > -1 && index != locTypeList.length - 1) {
    cType = locTypeList[index + 1];
  }
  return cType;
}

getTwoDecimalFixed(num){
  if(!isNaN(num)){
    return parseFloat(num).toFixed(2);
  }
  return num;
}

getFiveDecimalFixed(num){
  if(!isNaN(num)){
    let k = num.toString();
    let string = k.split('.');
    let numberOfDigitAfterDecimal = string[1]?string[1].length:0;
    if(numberOfDigitAfterDecimal<5)
     return num;
    else
     return parseFloat(num).toFixed(5);
  }
  return num;
}

setMarkerPostData(dataType: any,type:string) {
  let sDate : any = new Date (this.getRainfallStartTsofDay());
  let eDate : any = new Date().getTime() //sDate.setDate(sDate.getDate()+6)
  let postData: any = {
    "src": dataType == 'RIVER_GAUGE' ? "STATE_AND_CENTRAL_STATIONS" : dataType == 'RESERVOIR' ? "ALL" : '',
    "format": dataType == 'RIVER_GAUGE' ? "HOURLY" : dataType == 'RESERVOIR' ? "HOURLY" : '',
    "pType": dataType == 'RIVER_GAUGE' ? "COUNTRY" : dataType == 'RESERVOIR' ? "STATE" : '',
    "pEUUID" : dataType == 'RIVER_GAUGE' ? ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'] : dataType == 'RESERVOIR' ? ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'] : '',
    "sDate": dataType == 'RESERVOIR'  ? this.getResStartTsofDay() : this.getRainfallStartTsofDay(),
    "eDate": eDate,
    "cTypeList": [
      dataType
    ],
    "classification": [
      "INSTANT_DATA"
    ],
    // "widgetsTypeList": [
    //   "flood_alerts"
    // ]
  }
  postData['basinUUID'] =''
  return postData;
}
setPostData(dataType: any,type:string) {
  let postData: any = {
    "src": dataType == 'RIVER_GAUGE' ? "STATE_AND_CENTRAL_STATIONS" : dataType == 'RESERVOIR' ? "ALL" : '',
    "format": dataType == 'RIVER_GAUGE' ? "HOURLY" : dataType == 'RESERVOIR' ? "HOURLY" : '',
    "pType": dataType == 'RIVER_GAUGE' ? "COUNTRY" : dataType == 'RESERVOIR' ? "STATE" : '',
    "pEUUID" : dataType == 'RIVER_GAUGE' ? ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'] : dataType == 'RESERVOIR' ? ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'] : '',
    "sDate": dataType == 'RESERVOIR'  ? this.getResStartTsofDay() : this.getRainfallStartTsofDay(),
    "eDate": new Date().getTime(),
    "cTypeList": [
      dataType
    ],
    "classification": [
      "INSTANT_DATA"
    ]
  }
  if(type == 'cardClick'){
    postData['basinUUID'] =''
  }
  else if(type == 'default'){
    postData['bUUID'] = ''
  }
  return postData;
}



  getLayerList() {
    return this.layerList.asObservable();
  }

  setLayerList(value: any) {
    this.layerList.next(value);
  }

  getOtherOptions() {
    return this.otherOptions.asObservable();
  }

  setOtherOptions(value: any) {
    this.otherOptions.next(value);
  }

  getCurrentPlayPosition() {
    return this.currentPlayPosition.asObservable();
  }

  setCurrentPlayPosition(value: any) {
    this.currentPlayPosition.next(value);
  }

  currentDayTimestep(value: any) {
    let date = new Date(value);
    date.setHours(5);
    date.setMinutes(30);
    date.setSeconds(0);
    let time = date.getTime().toString();
    let timestepvalue = Number(time.substring(0, 10) + '000')
    return timestepvalue;
  }

  getCurrentDayWithTime() {
    let date = new Date();
    date.setHours(5);
    date.setMinutes(30);
    date.setSeconds(0);
    let time = date.getTime();
    return time;
  }
  getDecimalFixedWithRespectToDigit(num){
    if(!isNaN(num))
    {
      let k, value;
      k = num.toString();
      let string = k.split('.');
      let numberOfDigitBeforeDecimal = string[0].length;
      if(numberOfDigitBeforeDecimal == 1)
      {
      num = this.getTwoDecimalFixed(num);
        // return num
      } 
      else{
        num = this.getOneDecimalFixed(num);
        // return num;
      }
      return num;
    }
  }

  getOneDecimalFixed(num){
    if(!isNaN(num)){
      return parseFloat(num).toFixed(1);
    }
    return num;
  }
  
  fixedToDecimal(value, decimalNumber) {
    if (isNullOrUndefined(value)) {
      return '-';
    }
    return parseFloat(value).toFixed(decimalNumber);
  }

  getDecimalFixed(num){
    if(!isNaN(num))
    {
      if( num == parseInt(num) ){
        if(num>1000 && num<=9999 || num < -1000 && num >= -9999){
          return num.toString()[0]+','+num.toString().slice(1);
        }else{
          // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ;
          num = num.toLocaleString('en-IN');
          // num=num  ? Number(num.toFixed(1)).toLocaleString('en-IN'): '-';
          return num;
        }               
      }
      else{
        if(num>1000 && num<=9999 || num < -1000 && num >= -9999){
          return num ? num.toString()[0]+','+num.toFixed(1).toString().slice(1) : '-';
          // return num ? num.toString()[0]+','+num.toString().slice(1) : '-';
        }else{
          // num=num ? (num.toFixed(1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")  : '-';
          num = Number(num.toFixed(1)).toLocaleString('en-IN');
          // num=num ? Number(num.toFixed(1)).toLocaleString('en-IN') : '-';
          return num;
        }
      }
    } 
    return;
  }

  getCurrentRainfallDate() {
    let currentDate = new Date();
    let currentTs = new Date().setHours(0, 0, 0, 0);
    let rfStartofDay = currentTs + 8.5 * 3600 * 1000;
    let startTs, endTs;
    if (currentDate.getTime() <= rfStartofDay) {
      startTs = rfStartofDay - 24 * 3600 * 1000;
    } else {
      startTs = rfStartofDay;
    }
    return new Date(startTs);

  }

  getRainfallStartTsofDay() {
    let currentDate = new Date();
    let currentTs = new Date().setHours(0, 0, 0, 0);
    let rfStartofDay = currentTs + 8.5 * 3600 * 1000;
    let startTs, endTs;
    if (currentDate.getTime() <= rfStartofDay) {
      startTs = rfStartofDay - 24 * 3600 * 1000;
    } else {
      startTs = rfStartofDay;
    }
    return startTs;
  }

  getResStartTsofDay() {
    let currentDate = new Date();
    let currentTs = new Date().setHours(0, 0, 0, 0);
    let rfStartofDay = currentTs;
    let startTs, endTs;
    // if (currentDate.getTime() <= rfStartofDay) {
    //   startTs = rfStartofDay - 24 * 3600 * 1000;
    // } else {
      startTs = rfStartofDay;
    // }
    return startTs;
  }

  getRainfallEndTsofDay() {
    let currentDate = new Date();
    let currentTs = new Date().setHours(0, 0, 0, 0);
    let rfStartofDay = currentTs + 8.5 * 3600 * 1000;
    let startTs, endTs;
    if (currentDate.getTime() <= rfStartofDay) {
      startTs = rfStartofDay - 24 * 3600 * 1000;
    } else {
      startTs = rfStartofDay;
    }

    endTs = startTs + 24 * 3600 * 1000 - 1;
    return endTs;
  }

  getLayerWithFilter(layerName,filter?,year?,src?){
    let layerURL 
    {
      layerURL = this.urlConstants.AZURE_GEOSERVER_URL +  "HEATWAVE/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=HEATWAVE:"+layerName+"&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    }
      if(filter)
      {
        layerURL +='&cql_filter='+filter
          
      }
    
    return this.http.get<any>(layerURL);
  }
  getLayerWithFilterVass(layerName,filter?){
    let layerURL = this.urlConstants.AZURE_GEOSERVER_URL + "HEATWAVE/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=HEATWAVE:"+layerName+"&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    if(filter)
    layerURL +='&cql_filter='+filter;
    return this.http.get<any>(layerURL);
  }
  // getSourceListForComponent(component): Observable<any> {
  //     return this.http.get<any>(this.urlConstants.PLAY_URL + "comm/src/" + component).pipe(
  //       map(data => data.sort((a, b) => (a.value > b.value) ? 1 : -1)),
  //       catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
  //     );
  // }

  getLocationHierarchy(options : object) : Observable<any> {
    return this.http.post<any>(this.urlConstants.URL + "locations/allChildrenForParentChildType", options).pipe(
      catchError(this.errorHandler.handleError('All Locations Data request', []))
    );
  }
  flattenObject(data) {
    return data.map((value, key) => this.flattenOneObject(value));
  }

  flattenOneObject(ob) {
    if (typeof ob === 'string') {
      return ob;
    }
    const toReturn = {};
    for (const i in ob) {
      if (!ob.hasOwnProperty(i)) { continue; }
      // tslint:disable-next-line: triple-equals
      if ((typeof ob[i]) == 'object' && !(ob[i] instanceof Array)) {
        const flatObject = this.flattenOneObject(ob[i]);
        for (const x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) { continue; }
          toReturn[i + '.' + x] = flatObject[x];
        }
      } else {
        toReturn[i] = ob[i];
      }
    }
    return toReturn;
  }

  post(url, postData,params?): Observable<any> {
    return this.http.post<any>(this.urlConstants.URL + url, postData);
  }

  getPostDataForBreadCrumb(selectedParams) {
    let postData = {
      locName: selectedParams['locName'],
      locUUID: selectedParams['pUUID'],
      locType: selectedParams['pType'],
      component: selectedParams['component'].toLowerCase(),
      view: selectedParams['view'],
      src: selectedParams['src'],
      pEUUID:selectedParams['pEUUID']
    }
    if(selectedParams['dashboardView'] == VisibilityMapConstants.LOCATIONS.TAMILNADU && selectedParams['view'] == VisibilityMapConstants.VIEWS.BASIN){
      postData.pEUUID = LOCATION_UUID[selectedParams['location']['NAME'].toUpperCase()][selectedParams['view']].UUID;
    }
    return postData;
  } 

  getPostDataForTanksBreadcrumb(selectedParams) {
    let postData = {
      locName: selectedParams['location']['NAME'],
      locUUID: selectedParams['pUUID'],
      locType: selectedParams['pType'],
      component: "mitank",
      view: selectedParams['view'],
      src: selectedParams['src'],
      pEUUID:LOCATION_UUID[VisibilityMapConstants.LOCATIONS.GODAVARI],
      dept:selectedParams['type'],
    }
    return postData;
  }


  getPostDataForGWMSBreadcrumb(selectedParams)
  {
    let postData={
      "ay": selectedParams['year'],
      "locName": selectedParams['locName'],
      "locType": selectedParams['pType'],
      "locUUID": selectedParams['pUUID'],
      "stateUUID": "e98cd5b7-6556-4c0f-a778-3429e1c14a6b",
      "view": selectedParams['view'],
      // "component":"GWMS"
    }
    return postData;
  }

  addMaps(type,mapObj){
    if(type=='map1'){
      this.mapArray[0] = mapObj;
    }else if(type=='map2'){
      this.mapArray[1] = mapObj;
    }else if(type=='map3'){
      this.mapArray[2]= mapObj;
    }else if(type=='map4'){
      this.mapArray[3] = mapObj;
    }
    else if(type=='map'){
      this.mapArray[4] = mapObj;
    }
  }

  maker (z) {
    return {
        offsetFn: function (center, zoom, rm, tm) {
            return {center: center, zoom: zoom + z}; 
        }
    };
}



  setSelectedParams(value) {
    this.selectedParams.next(value);
  }
  
  getSelectedParams() {
    return this.selectedParams.asObservable();
  }

  createLegend() {
    return new (L as any).Control.HtmlLegend({
      position: 'bottomright',
      collapseSimple: false,
      detectStretched: false,
      collapsedOnInit: false
    });
  }

  getLegendData(data, layerInstance) {
    const legend = {
      name: data.title,
      layer: layerInstance,
      headerStyle: {
        width: '130px'
      }
    };

    legend['elements'] = [];
    const isTrue = 1;
    if (isTrue == 1 && data.levels.length > 0) {
      let html = ``;
      for (let key = 0; key < data.levels.length; key++) {

        if (data.levels[key].image) {
          html += `<p style='height:30px;margin:0px;padding:4px;width:130px;font-size: 1.2em;font-weight: bolder;color:black;background-color: ${data.levels[key].color}'>
             ${data.levels[key].name} <img src='${data.levels[key].image}'></p>`;
        } else {
          html += `<p style='height:25px;margin:0px;padding:4px;color:black;font-size: 1.2em;width:130px; font-weight: bolder; background-color: ${data.levels[key].color}'>${data.levels[key].name}</p>`;
        }
      }
      legend['elements'].push({ html });

    } else if (data.levels) {
      let obj;
      if (!(data.levels instanceof Array)) {
        const periodWiseLegend = {};
        for (const period in data.levels) {
          const tempLegend = {
            name: data.title,
            layer: layerInstance,
            elements: []
          };

          data.levels[period].forEach(level => {
            obj = {};
            obj['html'] = '';
            if (level['image'] != undefined && level['image'] != '')
              obj['html'] = '<img style=\'width:13px;height:13px;\' src=\'' + level['image'] + '\'/>';

            obj['label'] = level.name;

            obj['style'] = { 'background-color': level.color, width: '13px', height: '13px' };
            tempLegend.elements.push(obj);
          });

          periodWiseLegend[period] = tempLegend;
        }
        return periodWiseLegend;
      } else {
        data.levels.forEach(level => {
          obj = {};
          obj['html'] = '';
          if (level['image'] != undefined && level['image'] != '')
            obj['html'] = '<img style=\'width:13px;height:13px;\' src=\'' + level['image'] + '\'/>';
          obj['label'] = level.name;
          obj['style'] = { 'background-color': level.color, width: '13px', height: '13px' };
          legend['elements'].push(obj);
        });
      }
    }
    return legend;
  }

  getBarChartData(labels,categories,chartData) {
    // Highcharts.setOptions({
    //       time: {
    //         useUTC: false
    //       }
    //     });
    // Desired bar index (e.g., align with the "Now" bar)
    const desiredBarIndex = labels.indexOf('Now');
    const xAxisLabels = chartData.map(group => group.name).join('  ');  // Join all stack names into a single label per category
    // Conditionally set plotLines for the desired bar
    const plotLinesConfig =
      chartData.length > 3
        ? [
          {
            color: 'white', // Line color
            width: 2,       // Line width
            value: 0, // Index of the desired bar (e.g., 'Now')
            dashStyle: 'Dash', // Line style
            zIndex: 5         // Draw above columns
          }
        ]
        : [];
        console.log("plotLinesConfig",plotLinesConfig);
        
    let options: object = {
      chart: {
        type: 'column',
        backgroundColor: '#282828'
      },
      title: {
        text: ''
      },
      // subtitle: {
      //   text:
      //     'Source: <a target="_blank" ' +
      //     'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>'
      // },
      xAxis: {
        categories: categories,
        crosshair: true,
        title: {
          text: 'Time',
          // align: 'high', // Positions the title above the axis
          // offset: 10, // Adjust the vertical offset as needed
          style : {
            color: '#ffffff'
          }
        },
        // accessibility: {
        //   description: 'Countries'
        // },
        labels: {
          // formatter: function() {
          //   return xAxisLabels;  // Display all series names for each category on x-axis
          // },
          style: {
            color: 'white'
          },
          // format: '{value}',
          // format: '{value:%e-%b-%Y %H:%M:%S}',
          // tickPixelInterval: 5
        }
        // plotLines: plotLinesConfig
      },
      legend: {
        itemStyle: {
          color: '#ffffff',  // Set legend font color
          fontWeight: 'bold' // Optional: make the font bold
        },
        enabled: false
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Rainfall (mm)',
          style : {
            color: '#ffffff'
          }
        },
        labels: {
          style: {
            color: 'white'
          },
          // format: '{value}',
          // format: '{value:%e-%b-%Y %H:%M:%S}',
          // tickPixelInterval: 5
        }
      },
      tooltip: {
        valueSuffix: ' (mm)'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          pointPadding: 0.2,
          // borderWidth: 0,
          // pointPadding: 0.2,
          borderWidth: 1,       // Adds a visible white line
          borderColor: 'white', // Makes the border color white
          // dataLabels: {
          //   enabled: true,
          //   verticalAlign: 'top',  // Move labels to the top
          //   align: 'center',        // Center labels over each stack
          //   y: -10,                  // Adjust spacing from the top
          //   style: {
          //     fontWeight: 'bold',
          //     color: '#000'
          //   }
          // }
        }
      },
      // series: [
      //   {
      //     name: 'Day -3',
      //     data: [7, 2, 1.0, 3, 5.0, 4.3],
      //     color: 'orange'
      //   },
      //   {
      //     name: 'Day -2',
      //     data: [4.53, 1.400, 1.00, 1.405, 1.95, 1.13],
      //     color: 'green'
      //   },
      //   {
      //     name: 'Day -1',
      //     data: [4.5, 1.40, 1.00, 1.4, 1.9, 1.3],
      //     color: 'yellow'
      //   },
      //   {
      //     name: 'Today',
      //     data: [4, 1.4, 1, 1.4, 1, 11],
      //     color: '#e75480'
      //   },
      //   {
      //     name: 'Day 1',
      //     data: [3.8, 2.8, 1.2, 6, 5, 3],
      //     color: 'red'
      //   },
      //   {
      //     name: 'Day 2',
      //     data: [4, 1.4, 1, 1.4, 1, 1.1],
      //     color: 'green'
      //   },
      //   {
      //     name: 'Day 3',
      //     data: [0.3, 1.0, 1.00, 1.5, 1.5, 0.9],
      //     color: 'orange'
      //   },
      // ],
      series: chartData,
      //   exporting: {
      //     enabled: true,
      //     chartOptions:{
      //         title:{
      //             text: ''
      //         },
      //         chart: {
      //           backgroundColor: '#000000' // Set black background for export
      //         },
      //     },
      //     buttons: {
      //         contextButton: {
      //             menuItems: [
      //                 'downloadJPEG',
      //                 'downloadPNG',
      //                 'downloadSVG',
      //                 'downloadPDF'
      //             ]
      //         }
      //     }
      // },
      credits: {
        enabled: false
      }
    }
    return options;
  }

  deepClone(object): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj = ( object.constructor() as any);
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }


  getSimpleDateStringWithoutTime(timestamp) {
    let monthShortLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (isNaN(timestamp)) {
      return "--";
    }
    else {
      let numTimestamp = Number(timestamp);
      let currentDate = new Date(numTimestamp);
      let date = currentDate.getDate();
      let cd = date < 10 ? "0" + date : date;
      let dateValue = cd + '-' + (monthShortLabel[currentDate.getMonth()]) + '-' + currentDate.getFullYear();
      return dateValue;
    }
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

  isEmptyField(value: any) {
    if (isNullOrUndefined(value) || value === '') {
        return true;
    }
    return false;
  }

  get(url, postData): Observable<any> {
    return this.http.get<any>(this.urlConstants.URL + url + postData);
  }
  post1(url, postData): Observable<any> {
    return this.http.post<any>(url, postData);
  }

  get1(url, postData): Observable<any> {
    return this.http.get<any>(this.urlConstants.WRIMS_URL + url + postData);
  }

  getAPI(url, postData): Observable<any> {
    return this.http.get<any>(this.urlConstants.URL + url + postData);
  }
  postAPI(url, postData): Observable<any> {
    return this.http.post<any>(this.urlConstants.URL + url, postData);
  }

  public placeMultipleAPICalls(apiConfigArray): Observable<any> {
    const joinList = [];
    apiConfigArray.forEach(apiConfig => {
      joinList.push(apiConfig);
    });
    return forkJoin(joinList);
  }

  geoJsonCall(url: any) {
    return this.http.get<any>(url);
  }

  getRiverFlowDataToStyle(postData: any) {
    let url: any =this.urlConstants.URL + 'glofas/'+ postData.basinuuid + '/hms_combined/'+ postData.currDayTimestep+ '/' + postData.endDate;
    return this.http.get<any>(url);
  }

  getAllMarkersColourInfo(postData) {
    let api = this.urlConstants.URL + "rf/getAlertDataByWeatherDataType";
    return this.http.post<any>(api, postData);
  }

  getMarkerColorData(postData){
    let api = this.urlConstants.URL + "flowforecast/flowwidgets/floodalertsdata";
    return this.http.post<any>(api, postData);
  }

  getRatingData(postData){
    let api = this.urlConstants.URL + "reservoir/ratingdata/fetch/"+postData;
    return this.http.get<any>(api);
  }

  getMetaDataForAllPoints(postData: any) {
    return this.http.get<any>(this.urlConstants.URL + "flowmanagement/masterdata/root/" + postData.basinUUID);
  }

  getHecHmsMetaDataForAllPoints(postData: any) {
    let url: any = this.urlConstants.URL + "flowmanagement/masterdata/root/" + postData.basinUUID;
    return this.http.get<any>(url);
  }

  getMasterData(postData: any){
    postData.eType = postData.eType == 'RIVER_GAUGE' ? 'RIVERGAUGE' : 'RESERVOIR';
    let url =this.urlConstants.URL  + 'flowforecast/masterdata';
    return this.http.post<any>(url,postData);
  }

  getAlertsCount(postData: any) {
    let url =this.urlConstants.URL  + 'flowforecast/counts';
    return this.http.post<any>(url,postData);
  }

  getObservedlast3DaysData(postData : any){
    let url =this.urlConstants.WRIMS_URL  + 'rf/observeRainfallAlertData';
    return this.http.post<any>(url,postData);
  }

  getObservedRealtimeData(postData : any){
    let url =this.urlConstants.WRIMS_URL  + 'rf/getRealTimeRainfallAlertData';
    return this.http.post<any>(url,postData);
  }

  getForecastNext3DaysData(postData : any){
    let url =this.urlConstants.URL  + 'weatherForecast/get3DayRfAlertDataForCatchment';
    return this.http.post<any>(url,postData);
  }

  getForcastNext3hoursData(postData : any){
    let url =this.urlConstants.URL  + 'weatherForecast/get3HrRfAlertDataForCatchment';
    return this.http.post<any>(url,postData);
  }

  getNowcastData(postData : any){
    let url =this.urlConstants.URL  + 'nowcast/getNowcastRfAlertData';
    return this.http.post<any>(url,postData);
  }

  getAllReservoirMetaData(){
    let url = "https://apwrims-staging.vassarlabs.com/api/reservoir/map/all";
    let httpoption = new HttpHeaders({'Content-Type':'application/json'}) 
    return this.http.get<any>(url,{headers: httpoption});
  }

  getAllRivergaugeMetaData(postData : any){
    let url = "https://apwrims-staging.vassarlabs.com/api/rg/getcwcrivergaugedata";
    return this.http.post<any>(url,postData);
  }

  getAllMITanksMetaData(postData : any){
    let url =this.urlConstants.URL  + 'rf/observeRainfallAlertData';
    return this.http.post<any>(url,postData);
  }

  getAllCitiesMetaData(postData : any){
    let url =this.urlConstants.URL  + 'rf/observeRainfallAlertData';
    return this.http.post<any>(url,postData);
  }

  getReservoirMetaData(postData : any){
    let url ='https://apwrims-staging.vassarlabs.com/api/wateraudit/data/component';
    return this.http.post<any>(url,postData);
  }

  getAlertsHourlyHeatmaps(){
    let url =this.urlConstants.WRIMS_URL  + 'rf/getRFAlertHeatMap/APSDPS/HOURLY';
    return this.http.get<any>(url);
  }

  getAlertsDailyHeatmaps(){
    let url =this.urlConstants.WRIMS_URL  + 'rf/getRFAlertHeatMap/APSDPS/DAILY';
    return this.http.get<any>(url);
  }

  getNowcastHeatmaps() {
    let url =this.urlConstants.URL  + 'nowcast/getRFAlertHeatMaps/IMD_RADAR_RF_ALERT';
    return this.http.get<any>(url);
  }
  
  getAlertsForecastHourlyHeatmaps(source :any){
    let url =this.urlConstants.URL  + 'weatherForecast/getWeatherRFAlertHeatMap/'+source+'/RADAR_CTT_EUMETSAT_RF_ALERT/HOURLY';
    return this.http.get<any>(url);
  }

  getAlertsForecastDailyHeatmaps(source :any){
    let url =this.urlConstants.URL  + 'weatherForecast/getWeatherRFAlertHeatMap/'+source+'/RADAR_CTT_EUMETSAT_RF_ALERT/DAILY';
    return this.http.get<any>(url);
  }
  

  getTimestamps() {
    const now = new Date();

    // Calculate endTs (today's 8:30 AM)
    const endTsDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()-1, 8, 30, 0);
    const endTs = endTsDate.getTime();

    // Calculate startTs (3 days back at 8:30 AM)
    const startTsDate = new Date(endTsDate);
    startTsDate.setDate(startTsDate.getDate() - 2);
    const startTs = startTsDate.getTime();

    return { 'startTs': startTs, 'endTs': endTs };
  }

  getTimeStampForDate(tdate :any){
    var year, month, day;
    year = tdate.substring(0, 4);
    month = tdate.substring(4, 6);
    day = tdate.substring(6, 8);
    // let timestamp =  new Date(year, month - 1, day);
    const timestamp = new Date(Number(year), Number(month) - 1, Number(day), 8, 30, 0).getTime();
    return Number(timestamp); 
  }


  getNowcastTime() {
    const now = new Date();

    // Calculate endTs (today's 8:30 AM)
    const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 8, 30, 0);
    const startTs = startDate.getTime();

    const endDate = new Date();
    const endTs = endDate.getTime();

    return { 'startTs': startTs, 'endTs': endTs };

  }

  getForecastTimestamps() {
    // Get the current date and time
    let now = new Date();
    const startDate = new Date(now)
    startDate.setHours(startDate.getHours() + 2, 0, 0, 0); // Set to the start of the previous hour
    const startTs = startDate.getTime();

    const endTime = new Date(startDate);
    endTime.setHours(startDate.getHours() + 24, 0, 0, 0); // Set to the start of the previous hour
    const endTs = endTime.getTime()
    // Set startTs to current hour + 2 hours
    // const startTs = new Date(now.getTime() + 2 * 60 * 60 * 1000); // 2 hours in milliseconds

    // Set endTs to startTs + 24 hours
    // const endTs = new Date(startTs.getTime() + 24 * 60 * 60 * 1000); // 24 hours in milliseconds

    // Set forecastStartTs to endTs
    const forecastStartTs = endTs;

    // Set forecastEndTs to endTs + 3 days
    let forecastEndDate = new Date(forecastStartTs);
    forecastEndDate.setHours(forecastEndDate.getHours() + 72, 0, 0)
    const forecastEndTs = forecastEndDate.getTime()

    // Return the timestamps
    return {
      startTs: startTs,
      endTs: endTs,
      forecastStartTs: forecastStartTs,
      forecastEndTs: forecastEndTs
    };
  }

  getStartandEndHourTimestamps() {
    const currentDate = new Date();
    const timestamps = {};
    // Set start time to 5:30 AM today
    const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 5, 30, 0);
    timestamps['startTs'] = startOfDay.getTime()
    // Calculate the time one hour before the current hour
    const endTime = new Date(currentDate);
    endTime.setHours(currentDate.getHours() - 1, 0, 0, 0); // Set to the start of the previous hour
    timestamps['endTs'] = endTime.getTime()

    return timestamps;
  }

  formatTimestampToDate(timestamp) {
    const date = new Date(timestamp);
    
    // Extract day, month, and time
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' }); // e.g., Jan, Feb
    const time = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  
    return `${day}-${month} ${time}`;
  }

  convertToDateFormat(dateString: string): string {
    // Extract year, month, and day from the string
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1; // Months are 0-indexed
    const day = parseInt(dateString.substring(6, 8), 10);
  
    // Create a Date object
    const date = new Date(year, month, day);
  
    // Format to dd-MMM
    const formattedDate = `${day}-${date.toLocaleString('en-US', { month: 'short' })}`;
    return formattedDate;
  }

  getCurrentHourTimestamp(): number {
    const now = new Date();
    now.setMinutes(0, 0, 0); // Set minutes, seconds, and milliseconds to 0
    return now.getTime();
  }

  getReservoirData(postData) {
    let url = "https://apwrims.ap.gov.in/api/wateraudit/data/component";
    return this.http.post<any>(url,postData);  
  }

  getLocationData(type) {
    let url = this.urlConstants.URL + 'locations/allChildLocationList/cdf94322-30bf-456b-b0c6-b4038caebd6a/STATE/' + type;
    return this.http.get<any>(url);  
  }

  getNowcastRfAlertCount(postData) {
    let url = this.urlConstants.URL + 'nowcast/getNowcastRfAlertCount';
    return this.http.post<any>(url,postData);
  }

  getRfCoefficent(postData) {
    let url = this.urlConstants.URL + 'nowcast/rfcoefficent';
    return this.http.post<any>(url,postData);
  }

  getLastProcessedTime() {
    let url = this.urlConstants.URL + 'weatherForecast/getLatestProcessedTimeForSource/APSDPS'
    return this.http.get<any>(url);
  }

  toTitleCase(str: string) {
    const strng = [];
    str.split(' ').forEach((st: string) => {
      strng.push(st[0].toUpperCase() + st.substr(1).toLowerCase());
    });
    return strng.join(' ');
  }

  sortByTimestamp(data,isForecast) {
    const currentYear = new Date().getFullYear(); // Get the current year dynamically
  
    // Sort by timestamp
    const sortedData = data.sort((a, b) => {
      const dateA = new Date(`${currentYear} ${a.timeStamp}`);
      const dateB = new Date(`${currentYear} ${b.timeStamp}`);
      return dateA.getTime() - dateB.getTime();
    });

    if(isForecast) {
      // Update the day property after sorting
      sortedData.forEach((item, index) => {
        item.day = `Day ${index + 1}`;
      });
    }
    return sortedData;
  }

  areSameHour(timestamp1: number, timestamp2: number): boolean {
    const date1 = new Date(timestamp1);
    const date2 = new Date(timestamp2);
  
    // Compare year, month, date, and hour
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate() &&
      date1.getHours() === date2.getHours()
    );
  }

  formatTimestamps(startTimestamp: number, endTimestamp: number): string {
    const startDate = new Date(startTimestamp);
    const endDate = new Date(endTimestamp);

    const startDay = startDate.getDate().toString().padStart(2, '0');
    const startMonth = (startDate.getMonth() + 1).toString().padStart(2, '0');
    const startYear = startDate.getFullYear();

    const endDay = endDate.getDate().toString().padStart(2, '0');
    const endMonth = (endDate.getMonth() + 1).toString().padStart(2, '0');
    const endYear = endDate.getFullYear();

    const startTime = `${startDate.getHours()}:${startDate.getMinutes().toString().padStart(2, '0')}`;
    const endTime = `${endDate.getHours()}:${endDate.getMinutes().toString().padStart(2, '0')}`;

    // If the dates are the same but time is different
    if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
      return `${startDay}/${startMonth}/${startYear} (${startTime}-${endTime})`;
    }
    // If the dates are different
    else {
      return `${startDay}/${startMonth}/${startYear} (${startTime}) - ${endDay}/${endMonth}/${endYear} (${endTime})`;
    }
  }

  // Function to sort timestamps within each object's data
  sortForecastTimestamps(obj: any) {
    Object.keys(obj).forEach(key => {
      if (obj[key].data) {
        const sortedData = Object.keys(obj[key].data)
          .sort((a, b) => Number(a) - Number(b))
          .reduce((acc, timestamp) => {
            acc[timestamp] = obj[key].data[timestamp];
            return acc;
          }, {});
        obj[key].data = sortedData;
      }
    });
    return obj;
  }
  
  getPostDataTanksCount(params){
    let postData: any = {};
    postData  = {
      "pEUUID" : "cdf94322-30bf-456b-b0c6-b4038caebd6a",
      "pUUID" : "cdf94322-30bf-456b-b0c6-b4038caebd6a", //c7ec83ba-d5dc-4ab8-a118-cd6b0909e830
      "pType" : "STATE",    // DISTRICT, STATE
      "cType" : "DISTRICT", //BLOCK, DISTRICT
      "locType" : "CATCHMENT_AREA",
      "weatherDataType" : params['alertType'],    //ACTUAL_DAILY, ACTUAL_HOURLY, NOWCAST, FORECAST, ALL 
      "actualSource" : "APSDPS",
      "forecastSource" : params['source'],         //IMD_LONG_RANGE, ecmwf
      "nowcastSource" : "RADAR_CTT_EUMETSAT_RF_ALERT"
    }
    return postData;
  }

  getColumnValue(colName, row, hierarchy = []) {
    let columnValue = null;
    let valid = true, childData = row;
    for (let key of hierarchy) {
      if (childData[key] != null && childData[key] != undefined) {
        childData = childData[key];
      } else {
        valid = false;
        break;
      }
    }
    if (valid) {
      if (childData[colName] != null && childData[colName] != undefined) {
        columnValue = childData[colName];
      }
    }
    return columnValue;
  }
   findMaxValueKey(obj: any) {
      let maxKey : any = '';
      let maxValue : any = 0;
    
      for (const [key, value] of Object.entries(obj)) {
        if (value > maxValue) {
          maxValue = value;
          maxKey = key;
        }
      }
    
      return { 'maxKey' : maxKey, 'maxValue' : maxValue };
    }
}
